import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, model } from '@angular/core';
import { isEqual } from 'lodash-es';
import { MenuComponent } from '../menu.component';
import { MenuRadioComponent, MenuRadioItemInterface } from '../radio';

@Component({
  selector: 'shared-ui-menu-select',
  imports: [MenuComponent, MenuRadioComponent, NgTemplateOutlet],
  templateUrl: './menu-select.component.html',
  styleUrl: './menu-select.component.css',
})
export class MenuSelectComponent extends MenuComponent {
  items = input<MenuRadioItemInterface[]>();

  value = model<string | number | (string | number)[]>();

  isCheckSelectedItem = input<boolean>(false);

  menuItemClass = input<string>('');

  viewItems = computed(() =>
    this.items()?.map((item) => ({
      ...item,
      checked: isEqual(this.value(), item.value),
    })),
  );

  protected onMenuItemTriggered(dropdownItem: MenuRadioItemInterface): void {
    this.value.set(dropdownItem.value);
  }

  protected onDialogConfirm(
    value: string | number | (string | number)[] | undefined,
  ): void {
    this.value.set(value);
    this.dialogConfirm.emit(value);
  }
}
